<template>
  <div>
    <button 
      type="button" 
      class="btn-plain" 
      :class="tempmemo && tempmemo.trim() !== '' ? 'btn-heart-fill btn-note-fill' : 'btn-heart'"
      @click="showMemo"
    >
      <svg
          width="30"
          height="30"
          viewBox="70 70 160 160"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="memo-svg"
        >
        <g class="memo-icon-content">
          <polyline points="181.67,190.16 181.67,221.5 74.67,221.5 74.67,78.5 181.67,78.5 181.67,120.16"/>
          <g>
            <rect x="169.94" y="107.76" transform="matrix(0.7219 0.692 -0.692 0.7219 156.542 -85.1799)" width="28.64" height="88.85"/>
            <polygon points="138.57,199.86 140.79,189.07 149.26,197.19"/>
            <polygon points="137.26,201.23 142.67,174.88 163.34,194.7"/>
            <line x1="206.86" y1="128.6" x2="161.65" y2="175.77"/>
          </g>
        </g>
      </svg>
    </button>
    
    <b-modal v-if="visible" ref="myModalRef" :title="title"
      @hidden="hidden"
      cancel-title="キャンセル"
      :ok-title="okTitle"
      @ok.prevent="saveMemo"
      :ok-disabled="!memo || memo.trim() === ''"
    >
      <div class="d-block text-center">
        <textarea
          id="textarea1"
          v-model.trim="memo"
          class="form-control"
          rows="15"
        ></textarea>          
      </div>
    </b-modal>
  </div>
</template>
<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations, mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'Memo',
  props: ['applicant'],
  data() {
    return {
      applicantData: this.applicant,
      memo: this.applicant.memo,
      tempmemo: this.applicant.memo,
      okTitle: '保存',
      disabled:false,
      isMemoCleared:false,
      visible: false,
    };
  },
  computed: {
    ...mapGetters({
      user:'getCurrentUser'
    }),
    title() {
      return `${this.applicantData.last_name} ${this.applicantData.name} 様`;
    },
  },
  methods: {
    ...mapMutations({
      mutateApplicantsAfterMemo: 'mutateApplicantsAfterMemo'
    }),
    showMemo() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.myModalRef.show();
      });
    },

    hideModal() {
      this.$refs.myModalRef.hide();
    },
    hidden() {
      this.memo = this.tempmemo;
      this.visible = false;
    },
    saveMemo() {
      // Prevent saving empty memos
      if (!this.memo || this.memo.trim() === '') {
        return;
      }
      
      let timestamp = `[${moment().format('YYYY-MM-DD HH:mm')} ${this.user.name}]`;
      let flag = 0;

      if (this.tempmemo.trim() === '') {
        flag = 1;
        let memoLines = this.memo.split('\n');
        memoLines.push(timestamp);
        this.memo = memoLines.join('\n');
      }

      if (this.memo.trim() !== this.tempmemo.trim() && this.memo.trim() !== '' && flag === 0) {
        let lines = this.memo.split('\n');
        let tempLines = this.tempmemo ? this.tempmemo.split('\n') : [];
        let found = false;
        if (this.isMemoCleared) {
          let lines = this.memo.split('\n');
          lines.push(timestamp);
          this.memo = lines.join('\n');
        } else {
          let removeFlag=0;
          let j = 0; // Initialize j outside the loop
          for (let i = 0; i < tempLines.length; i++) {
            if (j >= lines.length || tempLines[i] !== lines[j]) {
              found = true;
              while (j < lines.length && lines[j].trim() !== '' && !lines[j].trim().startsWith('[')) {
                j++;
              }
              if (j < lines.length && lines[j].trim().startsWith('[')) {
                // console.log('here',j,lines[j]);
                lines[j] = timestamp;
              } else {
                // console.log('there',j,lines[j],lines[i]);
                if(!lines[j] && !lines[i]){
                  removeFlag=1;
                }
                if(lines[i]){
                  lines.splice(j, 0, timestamp);
                }
              }
              break;
            }
            j++;
          }
          if (j === lines.length && tempLines.length > lines.length && removeFlag === 0) {
            lines.push(timestamp);
          }
        }
        if (!found) {
          lines.push(timestamp);
        }

        this.memo = lines.join('\n');
      }
        this.okTitle = '読込中…';
        ApiService.put(Api.endpoints.CLIENT_MEMO(this.applicantData.id), {
          memo: this.memo,
        })// eslint-disable-next-line
            .then(({ data }) => {
            this.tempmemo = this.memo;
            this.okTitle = '保存';
            this.errorMessage = false;
            this.isMemoCleared = false;
            this.hideModal();
            this.mutateApplicantsAfterMemo(data.data);
          })
          .catch(({ response }) => {console.log(response);this.parseErrorResponse(response)});
      },
  },
  watch:{
    memo(newMemo){
      if(newMemo.trim() === ''){
        this.isMemoCleared = true;
      }
    },
    applicant(newApplicant) {
      this.tempmemo = newApplicant.memo;
      this.memo = newApplicant.memo;
    }
  },
};
</script>

<style scoped>
.memo-svg {
  transition: all 0.2s ease;
}

.memo-svg rect,
.memo-svg polygon,
.memo-svg line,
.memo-svg polyline {
  fill: none;
  stroke: #000000;
  stroke-width: 5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.memo-svg polygon:nth-child(2) {
  fill: #000000;
}

/* When the button has content (filled state) */
.btn-note-fill .memo-svg rect {
  /* fill: #e6d700; */
  stroke: black;
  fill: white;
}

/* Fill the paper/note background */
.btn-note-fill .memo-svg polyline {
  fill: #FFF100;
  stroke: black;
}

.btn-note-fill .memo-svg polygon,
.btn-note-fill .memo-svg line {
  stroke: black;
  fill: white;
}

/* Keep the pencil tip filled with dark color for contrast */
.btn-note-fill .memo-svg polygon:nth-child(2) {
  fill: #333333;
}
</style>
